import { API } from 'aws-amplify';

const getChallengesApi = async () => {
	return API.get(process.env.REACT_APP_NAME || '', '/challenges', {});
};

export { getChallengesApi };
